import React from "react";

import { Typography } from "new-components/typography/Typography";


type InlineCodeProps = {
  content: string;
};

export function InlineCode({ content }: InlineCodeProps) {
  return (
    <Typography
      noWrap
      variant="small"
      fontWeight="bold"
      className="font-code text-neutral-dark"
      sx={{ fontFamily: "JetBrains Mono" }}
    >
      {content}
    </Typography>
  );
}
